export default {
  reports: {
    header: {
      notes: 'Header for reports page',
      message: 'Reports',
    },
    model: {
      period: { notes: 'Month covered by the report', message: 'Period' },
      type: {
        title: { notes: 'Type of report', message: 'Type' },
        options: {
          rmsMonthly: {
            notes: 'RMS monthly report type label',
            message: 'Monthly',
          },
        },
      },
      company: {
        notes: 'Company associated with the report',
        message: 'Company',
      },
      site: { notes: 'Site associated with the report', message: 'Site' },
      equipment: {
        notes: 'Equipment covered by the report',
        message: 'Equipment',
      },
    },
  },
};
